<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'COMPLAINT_APPOINTMENT|Podgląd wizyty' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>

    <div class="dialog-body">
        <icc-complaint-appointment
            [appointment]="data.appointment"
            [document]="data.document"
            [preview]="true"
        >
        </icc-complaint-appointment>
    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>
